import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getEventSummary = function (seasonId,searchBy,searchValue,token) 
{
  const eventEndpoint = `/search/${searchBy}/${searchValue}/${seasonId}`;
  const eventURL =  `${URL.event}${eventEndpoint}`; 
  return getRequest(eventURL,'json',token);
}



// WEBPACK FOOTER //
// ./src/components/common/api/getEventSummary.js